const generateRandomString = () => `${(new Date()).getTime()}_${Math.random()}`;

export default generateRandomString;
